<template>
  <div class="step">
    <div class="step-wrapper">
      <h2>Повторный визит через <nobr>6 месяцев</nobr></h2>
      <ul>
        <li>Жалоб нет. Пациентка отмечает <b>отсутствие головокружения, восстановление равновесия</b>.</li>
        <li><b>Полностью вернулась к обычной жизни</b>, <nobr>не испытывает</nobr> ограничений в привычной ежедневной активности и занятиях спортом. Считает себя полностью выздоровевшей.</li>
        <li>При осмотре <b>стато-координаторные <nobr>и статокинетические</nobr> <br> пробы выполняет <nobr>в полном</nobr> объеме</b>.</li>
        <li>Явный и скрытый спонтанный <br> <b>нистагм <nobr>не определяется</nobr></b>.</li>
        <li><b>Тест Хальмаги отрицательный</b>: <br>при поворотах головы компенсаторная <br>саккада <nobr>не определяется</nobr>, что говорит<br> о восстановлении или адаптации <br>вестибуло-окулярного рефлекса.</li>
      </ul>
    </div>
    <div class="step-help">
      <div class="video-opener" @click="$emit('video', 'test')">
        <span>
          <img src="@/assets/test.png">
          Тест<br>Хальмаги
        </span>
      </div>
      <hand />
    </div>
    <div class="step-next" @click="$emit('reset')">
      <span>Начать сначала</span>
    </div>
    <img class="cover" src="@/assets/step-repeated.jpg">
  </div>
</template>

<script>
import Hand from './hand'

export default {
  components: {
    Hand
  }
}
</script>

<style lang="scss" scoped>
.step-help {
  right: 470px;
  top: 75%;

  @include media-down(lg) {
    right: 380px;
  }

  @include media-down(md) {
    transform: translate(0, 0);
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    margin: 20px auto;
  }

  &:before {
    transform: translate(-60%, -50%) rotate(20deg);
  }
}
h2 {
  @include media-down(md) {
    padding-right: 25% !important;
    margin-bottom: 20px !important;
    margin-top: 20px !important;
  }
}
ul {
  font-size: 16px;
  line-height: 1.15;
  color: #252628;
  padding: 0 320px 0 0;
  margin: 0;
  font-weight: normal;

  @include media-down(lg) {
    font-size: 14px;
    padding: 0 300px 0 0;
  }
  @include media-down(md) {
    padding: 0 25% 0 0;

    br {
      display: none;
    }
  }

  b {
    color: #009cde;
  }

  li {
    padding: 0 0 0 20px;
    margin: 15px 0;
    list-style: none;
    position: relative;

    @include media-down(lg) {
      margin: 12px 0;
    }

    &:before {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      left: 0;
      top: .35em;
      border-left: 10px solid #e97827;
      border-bottom: 5px solid transparent;
      border-top: 5px solid transparent;
    }
  }
}
.cover {
  position: absolute;
  border-radius: 50%;
  top: 0;
  right: 0;
  height: 100% !important;
  width: auto;

  @include media-down(md) {
    position: static;
    width: 25%;
    height: auto !important;
    order: -1;
    margin: 0 0 10px auto;
    position: absolute;
  }
}
</style>
